import _toConsumableArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './AccordionSteps.css';
import React from 'react';
import { get } from '../../utils';
import { RichText, Text, Link } from '@sitecore-jss/sitecore-jss-react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import IconPlus from '../atoms/Icons/IconPlus';
import IconMinus from '../atoms/Icons/IconMinus';
import { ReactComponent as ChevronRight } from '../../resources/icons/IconChevronRightLight.svg';
import { ReactComponent as ChevronLeft } from '../../resources/icons/IconChevronLeftLight.svg';
export var AccordionSteps = function AccordionSteps(_ref) {
  var fields = _ref.fields,
    params = _ref.params;
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  var _React$useState = React.useState([]),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    activeItemsIds = _React$useState2[0],
    setActiveItemsIds = _React$useState2[1];
  var hasTitle = Boolean(get(fields, 'data.item.title.jss.value'));
  var hasItems = Boolean(get(fields, 'data.item.children.length'));
  var items = hasItems ? fields.data.item.children : [];
  var filteredItems = !pageEditing ? items.filter(function (i) {
    return get(i, 'title.jss.value') && get(i, 'description.jss.value');
  }) : items;
  var middleArrIndex = hasItems ? Math.ceil(filteredItems.length / 2) : 0;
  var expandAllText = get(fields, 'data.item.expandAllText.jss.value');
  var collapseAllText = get(fields, 'data.item.collapseAllText.jss.value');
  var allItemsExpanded = pageEditing || filteredItems.length === activeItemsIds.length;
  var showStepNumbers = Boolean(get(fields, 'data.item.showStepNumbers.jss.value'));
  React.useEffect(function () {
    var isFirstExpanded = Boolean(get(fields, 'data.item.isFirstExpanded.jss.value'));

    // expanding all faq items if in page editing mode
    if (pageEditing) {
      setActiveItemsIds(filteredItems.map(function (i) {
        return i.id;
      }));
    } else if (isFirstExpanded && hasItems) setActiveItemsIds([filteredItems[0].id]);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  var handleAccordionItemClick = React.useCallback(function (e, id, isActive) {
    e.preventDefault();
    var nextActiveItemsIds = isActive ? activeItemsIds.filter(function (i) {
      return i !== id;
    }) : [].concat(_toConsumableArray(activeItemsIds), [id]);
    setActiveItemsIds(nextActiveItemsIds);
  }, [activeItemsIds]);
  var handleToggleAllItemsClick = React.useCallback(function (e) {
    e.preventDefault();
    var nextActiveItemsIds = allItemsExpanded ? [] : filteredItems.map(function (item) {
      return item.id;
    });
    setActiveItemsIds(nextActiveItemsIds);
  }, [allItemsExpanded, filteredItems]);
  if (!fields) {
    console.warn('AccordionSteps component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, "[AccordionSteps component is empty: please provide data source]");
    }
    return null;
  }
  var renderItem = function renderItem(item, number, pageEditing) {
    var isActive = activeItemsIds.includes(item.id);
    var ctaLabel = get(item, 'ctaLabel.jss.value');
    var ctaLink = get(item, 'ctaLink.jss.value.href');
    return /*#__PURE__*/React.createElement("div", {
      className: "accordion__list ".concat(isActive ? "accordion__list--active" : ""),
      key: item.id,
      "data-cy": "accordion-steps-single-step"
    }, /*#__PURE__*/React.createElement("p", {
      className: "accordion__heading body-medium",
      onClick: function onClick(e) {
        if (!pageEditing) handleAccordionItemClick(e, item.id, isActive);
      },
      onKeyPress: function onKeyPress(e) {
        if (e.key === " " || e.key === "Spacebar") {
          e.preventDefault();
          handleAccordionItemClick(e, item.id, isActive);
        }
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "accordion__anchor-wrapper"
    }, showStepNumbers && /*#__PURE__*/React.createElement("div", {
      className: "accordion__number",
      "data-cy": "accordion-steps-step-number"
    }, number < 10 ? '0' : '', number), /*#__PURE__*/React.createElement(Text, {
      tag: "a",
      className: "accordion__anchor",
      href: "/",
      field: item.title.jss,
      "data-cy": "accordion-steps-anchor-title"
    })), !pageEditing && /*#__PURE__*/React.createElement("span", {
      className: "accordion__icon"
    }, isActive ? /*#__PURE__*/React.createElement(IconMinus, null) : /*#__PURE__*/React.createElement(IconPlus, null))), isActive && /*#__PURE__*/React.createElement("div", {
      className: "accordion__content"
    }, /*#__PURE__*/React.createElement("p", {
      className: "body-small accordion__p"
    }, /*#__PURE__*/React.createElement(RichText, {
      tag: "span",
      field: item.description.jss,
      "data-cy": "accordion-steps-anchor-content"
    })), pageEditing ? /*#__PURE__*/React.createElement(Link, {
      className: "default-link",
      field: item.ctaLink.jss
    }, /*#__PURE__*/React.createElement(Text, {
      field: item.ctaLabel.jss
    }), rtl ? /*#__PURE__*/React.createElement(ChevronLeft, {
      className: "btn-link__icon"
    }) : /*#__PURE__*/React.createElement(ChevronRight, {
      className: "btn-link__icon"
    })) : ctaLabel && ctaLink && /*#__PURE__*/React.createElement("a", {
      className: "default-link accordion__cta-link",
      "aria-label": "Icon Title",
      href: item.ctaLink.jss.value.href
      // dataCy="accordion-steps-anchor-cta"
    }, /*#__PURE__*/React.createElement(Text, {
      field: item.ctaLabel.jss
    }), rtl ? /*#__PURE__*/React.createElement(ChevronLeft, {
      className: "btn-link__icon"
    }) : /*#__PURE__*/React.createElement(ChevronRight, {
      className: "btn-link__icon"
    }))));
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement("script", {
    type: "application/ld+json",
    dangerouslySetInnerHTML: {
      __html: "\n          {\n            \"@context\": \"https://schema.org\",\n            \"@type\": \"FAQPage\",\n            \"mainEntity\": [\n\n            ".concat(items.map(function (item) {
        return "{\n                \"@type\": \"Question\",gD\tgo to declaration\n                \"name\": ".concat(JSON.stringify(get(item, 'title.jss.value')), ",\n                \"acceptedAnswer\": {\n                  \"@type\": \"Answer\",\n                  \"text\": ").concat(JSON.stringify(get(item, 'description.jss.value')), "\n                }\n              }");
      }), "]\n          }")
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "row m01-accordion-steps"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "section-steps",
    "data-cy": "accordion-steps"
  }, hasTitle && /*#__PURE__*/React.createElement("div", {
    className: "h3 accordion-main-heading heading-w-link"
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "div",
    className: "step-title",
    field: fields.data.item.title.jss,
    "data-cy": "accordion-steps-title"
  }), !pageEditing && collapseAllText && expandAllText && /*#__PURE__*/React.createElement("div", {
    className: "expand-wrapper"
  }, /*#__PURE__*/React.createElement("a", {
    className: "expand-accordion-btn default-link",
    href: "/",
    "aria-label": "Collapse/Expand All",
    onClick: handleToggleAllItemsClick,
    "data-cy": "accordion-steps-expand-all"
  }, allItemsExpanded ? collapseAllText : expandAllText))), /*#__PURE__*/React.createElement("div", {
    className: "accordion ".concat(showStepNumbers ? 'accordion--steps' : 'accordion--faq')
  }, /*#__PURE__*/React.createElement("div", {
    className: "accordion__col accordion__col--left"
  }, filteredItems.map(function (item, index) {
    if (index < middleArrIndex) return renderItem(item, index + 1, pageEditing);
    return null;
  })), /*#__PURE__*/React.createElement("div", {
    className: "accordion__col accordion__col--right"
  }, filteredItems.map(function (item, index) {
    if (index >= middleArrIndex) return renderItem(item, index + 1, pageEditing);
    return null;
  })))))));
};
var StyledWrapper = function StyledWrapper(_ref2) {
  var children = _ref2.children,
    rtl = _ref2.rtl,
    anchorUrlParameter = _ref2.anchorUrlParameter;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    className: " ".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles)
  }, children);
};
var commonStyles = "c1bjgzsn";
var ltrStyles = "ltqohm6";
var rtlStyles = "rscf0lu";
export default AccordionSteps;